import { type ComponentProps } from 'react'
import { Checkbox as BasisCheckbox } from './basis/checkbox'
import { cn } from '@/utils'

export type CheckboxProps = Omit<
  ComponentProps<typeof BasisCheckbox>,
  'checked' | 'onCheckedChange'
> & {
  checked: boolean | 'indeterminate'
  onCheckedChange: (checked: boolean) => void
}

// Radix reports `boolean | 'indeterminate'`; a caller may SET the
// indeterminate state (SA-1329's select-all), but the wrapper still hands its
// callers a plain boolean: a click on a mixed box asks for "on".
// An unchecked box is only its edge, so it draws the muted foreground (3:1
// and more, as the native box it replaces did) over basis's field edge.
export function Checkbox({ className, onCheckedChange, ...props }: CheckboxProps) {
  return (
    <BasisCheckbox
      className={cn(
        'border-muted-foreground',
        // The mixed state: the checked fill with a bar in place of the tick.
        'data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
        'data-[state=indeterminate]:flex data-[state=indeterminate]:items-center data-[state=indeterminate]:justify-center',
        'data-[state=indeterminate]:after:block data-[state=indeterminate]:after:h-0.5 data-[state=indeterminate]:after:w-2 data-[state=indeterminate]:after:bg-current',
        '[&[data-state=indeterminate]_svg]:hidden',
        className,
      )}
      onCheckedChange={(checked) => onCheckedChange(checked === true)}
      {...props}
    />
  )
}

Checkbox.displayName = 'Checkbox'
